export default __webpack_public_path__ + "static/media/card-account-settings.829c28ab.svg";